import { render } from "./OnboardingVideo.vue?vue&type=template&id=c1efe148&scoped=true&ts=true"
import script from "./OnboardingVideo.vue?vue&type=script&lang=ts"
export * from "./OnboardingVideo.vue?vue&type=script&lang=ts"

import "./OnboardingVideo.vue?vue&type=style&index=0&id=c1efe148&lang=scss&scoped=true"

import exportComponent from "/home/franco/Desarrollos/NC/gramosDev/Gramos/FrontEnd/trunk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1efe148"]])

export default __exports__